import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { iArbitros, pouchdb2 } from '../pouchdb/pouchdb.service';
import { CodigosAmonestacion_API } from '../../models/codigosAmonestacion';
import {
  Designaciones_API,
  Designaciones_Param,
  Designaciones_Arbitros,
  TipoLicenciaMin
} from '../../models/designaciones';
import { LicenciasPorEquipo_Value } from '../../models/licencias';
import { Images_Value, Images_Params } from '../../models/fotos';
//import * as moment from 'moment';
import { Arbitros } from '../../models/arbitros';
import { iConfiguracion, iLogs } from '../../models/basePage';
import { Online } from '../../models/online/cfutbol';
import { Proxy } from '../proxy/proxy.service';
import { BaseService } from '../baseService';

export namespace API {
  export class iService extends BaseService {
    //public baseUrl: string = 'http://www.cfutbol.es/api/api/';
    //public baseUrl: string = "http://pruebas.cfutbol.es/api/api/";
    //public baseUrl: string = "http://localhost:52133/api/";

    constructor(public http: HttpClient, public http2: Http) {
      super(http, http2);
    }
  }

  // #region Códigos de amonestacion
  @Injectable()
  export class CodigosAmonestacionService extends iService {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    /**
     * Obtención de los códigos de amonestación. Este procedimiento, siempre obtendrá sus datos desde la primera dirección API disponible (primer parámetro = undefined)
     */
    get(): Promise<Array<CodigosAmonestacion_API>> {
      return this.GetUniqueApi(undefined, 'codigosAmonestacion/get');
    }
  }
  // #endregion

  // #region Designaciones
  @Injectable()
  export class DesignacionesService extends iService {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    post(datos: Designaciones_Param): Promise<Array<Designaciones_API>> {
      return this.Post(datos, 'designaciones/post');
    }

    put(datos: Designaciones_API): Promise<boolean> {
      return this.Put(datos, 'designaciones/put');
    }

    actualizarArbitrosPorDesignacion(arbitros: Designaciones_Arbitros, urlApi: string): Promise<boolean> {
      arbitros.urlApi = urlApi;
      return this.Post(arbitros, 'designaciones/actualizararbitrospordesignacion');
    }

    obtenerArbitrosPorDesignacion(idDesignacion: number, urlApi: string): Promise<Designaciones_Arbitros> {
      return this.GetUniqueApi(
        urlApi,
        'designaciones/obtenerarbitrospordesignacion?idDesignacion=' + idDesignacion
      );
    }

    porDesignacion(idDesignacion: number, nuevosDerechos: boolean, urlApi: string): Promise<Designaciones_API> {
      return this.GetUniqueApi(
        urlApi,
        'designaciones/porDesignacion?idDesignacion=' +
        idDesignacion.toString() +
        '&nuevosDerechosArbitrales=' +
        nuevosDerechos
      );
    }

    /**
     * Envía la lista de los registros de incidencias de la aplicación
     * @param datos Lista de registros de incidencias
     * @param idDesignacion Identificador de la designación asociada
     * @param urlApi    URL de la api que debe procesar el registro de incidencias relacionado con la designación
     */
    registroIncidencias(datos: Array<iLogs>, idDesignacion: number, urlApi: string): Promise<boolean> {
      return this.Post(
        datos,
        'designaciones/registroincidencias?idDesignacion=' +
        idDesignacion.toString() +
        '&registroIncidencias=true',
        urlApi
      );
    }

    sincronizar(datos: Designaciones_API): Promise<boolean> {
      return this.Post(
        datos,
        'designaciones/sincronizar?idDesignacion=' + datos.id_Designacion + '&sincronizar=true'
      );
    }

    test(datos: Designaciones_API): Promise<boolean> {
      return this.Post(datos, 'test?idDesignacion=' + datos.id_Designacion + '&test=true');
    }
  }
  // #endregion

  // #region Imagenes

  @Injectable()
  export class ImagenesService extends iService {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    get(id: number, dni: string, urlApi: string): Promise<Images_Value> {
      return this.GetUniqueApi(urlApi, 'images/get?id=' + id.toString() + '&dni=' + dni);
    }

    post(datos: Images_Params): Promise<any> {
      return this.Post(datos, 'images/post');
    }
  }

  // #endregion

  // #region Licencias

  @Injectable()
  export class LicenciasService extends iService {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    get(idEquipo: number, idDesignacion: number, urlBase: string): Promise<LicenciasPorEquipo_Value> {
      return this.GetUniqueApi(
        urlBase,
        'licenciasPorEquipo/get?Id_Equipo=' +
        idEquipo.toString() +
        '&id_Designacion=' +
        idDesignacion.toString()
      );
    }

    getTiposLicencias(): Promise<Array<TipoLicenciaMin>> {
      return this.GetUniqueApi(undefined, 'licenciasPorEquipo/GetTiposLicencias?getTiposLicencias=true');
    }
  }

  // #endregion

  // #region Usuarios
  @Injectable()
  export class UsuariosService extends iService {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }
    /**
     * Comprueba si el email pasado como parámetro, está registrado en la base de datos de Árbitros
     * @param email   Email a comprobar
     */
    check(email: string): Promise<number> {
      return this.GetUniqueApi(undefined, 'usuarios/check?datos=' + email);
    }

    post(datos: iArbitros): Promise<Arbitros> {
      return this.Post(datos, 'usuarios/post', this._configuraciones.api.urlAPIs[0].urlApi);
    }

    put(datos: iArbitros): Promise<boolean> {
      return this.Put(datos, 'usuarios/put', this._configuraciones.api.urlAPIs[0].urlApi);
    }
  }
  // #endregion

  @Injectable()
  export class ParametrosAlineacion {
    private params: any = {};

    constructor() { }

    public getParametros(): any {
      return this.params;
    }

    public setParametros(datos: any): void {
      this.params = datos;
    }
  }

  /**
   * Servicio para mantener la sesión del usuario validado
   */
  @Injectable()
  export class SessionService {
    // #region  Propiedades del controlador
    private usuario: iArbitros = null;
    // #endregion

    constructor() { }

    public getUsuario(): iArbitros {
      return this.usuario;
    }
    public setUsuario(datos: iArbitros): void {
      this.usuario = datos;
    }
  }
}

export namespace APIOnLine {
  export class iServiceOnLine extends BaseService {
    public baseUrlMiniatura: string = '';

    constructor(public http: HttpClient, public http2: Http) {
      super(http, http2);
      http2.get('./assets/data/datos.json').toPromise().then((resultado: any) => {
        let configuracion: iConfiguracion = <iConfiguracion>resultado.json();
        this.baseUrlMiniatura = configuracion.api.urlMiniatura;
      });
    }
  }

  // #region Persistentes
  @Injectable()
  export class Persistentes {
    private readonly _archivoJSON: string = './assets/data/datos.json';

    // #region Propiedades privadas de la clase
    private arbitro: Online.ArbitroBasico | pouchdb2.ArbitroBasicoDB;
    private configuraciones: iConfiguracion;
    private declaraciones: Online.DeclaracionesCOVIDDesignacion[];
    private designacion: Proxy.PrDesignaciones;
    private idEquipo: number; // Identificador del equipo
    private esIncidencias: boolean; // Indica si se está en la página de las incidencias (no amonestaciones)
    private golesLocal: number; // Número de goles del equipo local
    private golesVisitante: number; // Número de goles del equipo visitante
    // #endregion

    constructor(public http: Http) { }

    // #region Árbitro
    public GetArbitro(): Online.ArbitroBasico | pouchdb2.ArbitroBasicoDB {
      return this.arbitro;
    }
    public SetArbitro(_arbitro: Online.ArbitroBasico | pouchdb2.ArbitroBasicoDB): void {
      this.arbitro = _arbitro;
    }
    // #endregion

    // #region Configuraciones
    public GetConfiguracion(): Promise<iConfiguracion> {
      if (this.configuraciones != null) {
        return Promise.resolve(this.configuraciones);
      } else {
        return this.http
          .get(this._archivoJSON + '?v=' + new Date().getTime().toString())
          .toPromise()
          .then((resultado: any) => {
            this.configuraciones = <iConfiguracion>resultado.json();
            return Promise.resolve(this.configuraciones);
          })
          .catch((error) => {
            return Promise.reject('No se ha podido cargar el archivo con las configuraciones de la APP');
          });
      }
    }
    public SetConfiguracion(_configuraciones: iConfiguracion): void {
      this.configuraciones = _configuraciones;
    }
    // #endregion

    //#region
    public GetDeclaraciones(): Online.DeclaracionesCOVIDDesignacion[] {
      return this.declaraciones;
    }
    public SetDeclaraciones(_declaraciones: Online.DeclaracionesCOVIDDesignacion[]): void {
      this.declaraciones = _declaraciones;
    }
    //#endregion

    // #region Designación
    public GetDesignacion(): Proxy.PrDesignaciones {
      return this.designacion;
    }
    public SetDesignacion(_designacion: Proxy.PrDesignaciones, _idEquipo: number = undefined): void {
      this.designacion = _designacion;
      if (_idEquipo != undefined) {
        this.idEquipo = _idEquipo;
      }
    }
    // #endregion

    // #region Goles
    public GetGolesLocal(): number {
      return this.golesLocal;
    }
    public GetGolesVisitante(): number {
      return this.golesVisitante;
    }
    public SetGolesLocal(goles: number): void {
      this.golesLocal = goles;
    }
    public SetGolesVisitante(goles: number): void {
      this.golesVisitante = goles;
    }
    // #endregion

    // #region Identificador del equipo
    public GetIdEquipo(): number {
      return this.idEquipo;
    }
    public SetIdEquipo(_idEquipo: number): void {
      this.idEquipo = _idEquipo;
    }
    // #endregion

    // #region Es incidencias
    public GetEsIncidencias(): boolean {
      return this.esIncidencias;
    }
    public SetEsIncidencias(_esIncidencias: boolean): void {
      this.esIncidencias = _esIncidencias;
    }
    // #endregion
  }
  // #endregion

  // #region CFutbolActas (API en el servidor)
  @Injectable()
  export class CFutbolActas extends iServiceOnLine {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    // #region Alineaciones

    alineablesPorEquipo(
      urlBase: string,
      idEquipo: number,
      idDesignacion: number,
      fecha: string
    ): Promise<Array<Online.IPersonaAlineable>> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/alineablesPorEquipo/?idEquipo=' +
        idEquipo +
        '&idDesignacion=' +
        idDesignacion +
        '&fecha=' +
        fecha
      );
    }

    archivoAlineacion(
      urlBase: string,
      idDesignacion: number,
      idEquipo: number
    ): Promise<Online.IActa_Archivos_Alineaciones> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/archivoAlineacion/?idDesignacion=' + idDesignacion + '&idEquipo=' + idEquipo
      );
    }

    eliminarAlineado(datos: Online.IPersonaAlineable, idDesignacion: number): Promise<boolean> {
      return this.Post(datos, 'cFutbolActas/eliminarAlineado/?idDesignacion=' + idDesignacion.toString());
    }

    eliminarArchivoAlineacion(urlBase: string, idDesignacion: number, idEquipo: number): Promise<boolean> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/eliminarArchivoAlineacion/?idDesignacion=' + idDesignacion + '&idEquipo=' + idEquipo
      );
    }

    guardarAlineado(datos: Online.IPersonaAlineable, idDesignacion: number): Promise<Online.IPersonaAlineable> {
      return this.Post(datos, 'cFutbolActas/guardarAlineado/?idDesignacion=' + idDesignacion.toString());
    }

    guardarArchivoAlineaciones(datos: Online.Actas_Archivos_Alineaciones_ConDatos): Promise<any> {
      return this.Post(datos, 'cFutbolActas/guardarArchivoAlineacion/');
    }

    personaInhabilitada(datos: Online.IPersonaAlineable): Promise<boolean> {
      return this.Post(datos, 'cFutbolActas/personaInhabilitada/');
    }

    situacionesAlineablesPorDNI(urlBase: string, dni: string): Promise<Array<Online.IPersonaAlineable>> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/situacionesAlineablesPorDNI/?dni=' + dni);
    }

    // #endregion

    // #region Amonestaciones

    amonestacionesPorDesignacion(
      urlBase: string,
      idDesignacion: number,
      idEquipo: number
    ): Promise<Array<Online.IActas_Amonestaciones_Base>> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/amonestacionesPorDesignacion/?idDesignacion=' + idDesignacion + '&idEquipo=' + idEquipo
      );
    }

    codigosAmonestacion(urlApi: string): Promise<Array<Online.IActas_Codigos_Amonestacion>> {
      return this.GetUniqueApi(urlApi, 'cFutbolActas/codigosAmonestacion/?codigosAmonestacion=true');
    }

    eliminarAmonestacion(datos: Online.IActas_Amonestaciones_Base): Promise<boolean> {
      return this.Post(datos, 'cFutbolActas/eliminarAmonestacion/');
    }

    guardarAmonestacion(datos: Online.IActas_Amonestaciones_Base): Promise<Online.IActas_Amonestaciones_Base> {
      return this.Post(datos, 'cFutbolActas/guardarAmonestacion/');
    }

    // #endregion

    // #region Datos del árbitro

    datosArbitro(idArbitro: number, urlBase: string): Promise<Online.IArbitroDTO> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/datosArbitro?idArbitro=' + idArbitro.toString() + '&datosArbitro=true'
      );
    }

    // #endregion

    // #region Cambios

    cambiosPorDesignacion(
      urlBase: string,
      idDesignacion: number,
      idEquipo: number
    ): Promise<Array<Online.IActas_Cambios_Base>> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/cambiosPorDesignacion/?idDesignacion=' + idDesignacion + '&idEquipo=' + idEquipo
      );
    }

    eliminarCambio(datos: Online.IActas_Cambios_Base): Promise<boolean> {
      return this.Post(datos, 'cFutbolActas/eliminarCambio/');
    }

    guardarCambio(datos: Online.IActas_Cambios_Base): Promise<Online.IActas_Cambios_Base> {
      return this.Post(datos, 'cFutbolActas/guardarCambio/');
    }

    // #endregion

    // #region Confirmar alineaciones
    confirmacion(
      urlBase: string,
      idDesignacion: number,
      idEquipo: number
    ): Promise<Online.IActa_ConfirmarAlineacion> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/confirmacion/?idDesignacion=' + idDesignacion + '&idEquipo=' + idEquipo
      );
    }
    // #endregion

    // #region Configuraciones de las designaciones
    configuraciones(urlBase: string, idDesignacion: number): Promise<Online.IActa_Configuraciones> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/configuraciones/?idDesignacion=' + idDesignacion);
    }
    // #endregion

    // #region Custodia

    custodiaPorDesignacion(urlBase: string, idDesignacion: number): Promise<Online.IActa_Custodia> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/custodiaPorDesignacion/?idDesignacion=' + idDesignacion);
    }

    guardarCustodia(datos: Online.IActa_Custodia, actualizarFechaEntrega: boolean): Promise<Online.IActa_Custodia> {
      return this.Post(datos, 'cFutbolActas/guardarCustodia/?actualizarFechaEntrega=' + actualizarFechaEntrega);
    }

    // #endregion

    // #region Derechos arbitrales
    derechosArbitrales(urlBase: string, idDesignacion: number): Promise<Online.IActa_Derechos> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/derechosArbitrales/?idDesignacion=' + idDesignacion);
    }

    guardarDerechos(datos: Online.IActa_Derechos): Promise<Online.IActa_Derechos> {
      return this.Post(datos, 'cFutbolActas/guardarDerechos/');
    }

    saldoDisponible(urlBase: string, idEquipo: number): Promise<number> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/saldoDisponible/?idEquipo=' + idEquipo);
    }
    // #endregion

    // #region Designaciones

    actualizarColegiados(
      designacion: Online.IDesignacion,
      numeroArbitro2: number | null,
      numeroAsistente1: number | null,
      numeroAsistente2: number | null,
      numeroAsistente3: number | null,
      numeroAsistente4: number | null,
      numeroCronometrador: number | null
    ): Promise<Online.IDesignacion> {
      let cadena: string =
        'cFutbolActas/actualizarColegiados/?' +
        this.CadenaNumeroArbitro(numeroArbitro2, 'numeroArbitro2') +
        this.CadenaNumeroArbitro(numeroAsistente1, 'numeroAsistente1') +
        this.CadenaNumeroArbitro(numeroAsistente2, 'numeroAsistente2') +
        this.CadenaNumeroArbitro(numeroAsistente3, 'numeroAsistente3') +
        this.CadenaNumeroArbitro(numeroAsistente4, 'numeroAsistente4') +
        this.CadenaNumeroArbitro(numeroCronometrador, 'numeroCronometrador');

      return this.Post(designacion, cadena);
    }

    private CadenaNumeroArbitro(numero: number | null, cadena: string): string {
      let resultado: string = '';
      if (numero != null && numero > 0) {
        resultado = cadena + '=' + numero.toString() + '&';
      } else {
        resultado = cadena + '=null&';
      }
      return resultado;
    }

    designacionesPorArbitro(idArbitro: number): Promise<Array<Online.IDesignacion>> {
      return this.GetMultiplesApis('cFutbolActas/designacionesPorArbitro/?idArbitro=' + idArbitro, 0);
    }

    finalizarDesignacion(designacion: Online.IDesignacion): Promise<boolean> {
      return this.Post(designacion, 'cFutbolActas/finalizarDesignacion/');
    }
    // #endregion

    // #region Fotos
    fotoEnMiniatura(dni: string): Promise<string> {
      // Es importante que en la siguiente línea de código, se utilice "this.http.get" y no "this.GetUniqueApe", ya que la llamada
      // se realiza a la URL dada por this.baseUrlMiniatura, y no a las URLs de la API.
      return this.http
        .get<string>(this.baseUrlMiniatura + '?dni=' + dni + '&fotoEnMiniatura=true&width=800', {
          headers: this.GetHeaders()
        })
        .toPromise();
    }
    // #endregion

    // #region Fútbol sala

    informacionFutbolSala(urlBase: string, idDesignacion: number): Promise<Online.IActa_FutbolSala> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/informacionFutbolSala/?idDesignacion=' + idDesignacion);
    }

    guardarFutbolSala(datos: Online.IActa_FutbolSala): Promise<Online.IActa_FutbolSala> {
      return this.Post(datos, 'cFutbolActas/guardarFutbolSala/');
    }

    // #endregion

    // #region Goles

    golesPorDesignacion(urlBase: string, idDesignacion: number): Promise<Array<Online.IActa_Goles_Base>> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/golesPorDesignacion/?idDesignacion=' + idDesignacion);
    }

    eliminarGol(datos: Online.IActa_Goles_Base): Promise<boolean> {
      return this.GetUniqueApi(
        datos.urlApi,
        'cFutbolActas/eliminarGol/?idDesignacion=' +
        datos.idDesignacion +
        '&idEquipo=' +
        datos.idEquipo +
        '&idJugador=' +
        datos.idJugador +
        '&esPropiaPuerta=' + datos.propiaPuerta
      );
    }

    guardarGol(datos: Online.IActa_Goles_Base): Promise<Online.IActa_Goles_Base> {
      return this.Post(datos, 'cFutbolActas/guardarGol/');
    }

    // #endregion

    // #region Mensajes
    tieneMensajesObligatoriosSinLeer(idArbitro: number): Promise<boolean> {
      return this.GetUniqueApi(
        this._configuraciones.api.urlAPIs[0].urlApi,
        'cFutbolActas/tieneMensajesObligatoriosSinLeer?idArbitro=' + idArbitro.toString()
      );
    }
    // #endregion

    // #region Otros datos del acta
    guardarOtros(otros: Online.IActasOtros): Promise<Online.IActasOtros> {
      return this.Post(otros, 'cFutbolActas/guardarOtros');
    }

    listaMotivosSuspension(): Promise<string[]> {
      return this.GetListElements(undefined, 'cFutbolActas/listaMotivosSuspension');
    }

    otros(urlBase: string, idDesignacion: number): Promise<Online.IActasOtros> {
      return this.GetUniqueApi(urlBase, 'cFutbolActas/otros/?idDesignacion=' + idDesignacion);
    }
    // #endregion

    // #region Participación
    eliminarParticipante(datos: Online.IActa_Participacion): Promise<boolean> {
      return this.Post(datos, 'cFutbolActas/eliminarParticipante');
    }

    guardarParticipante(datos: Online.IActa_Participacion): Promise<Online.IActa_Participacion> {
      return this.Post(datos, 'cFutbolActas/guardarParticipante/?guardarParticipante=true');
    }

    participantes(
      urlBase: string,
      idDesignacion: number,
      idEquipo: number
    ): Promise<Array<Online.IActa_Participacion>> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/participantes/?idDesignacion=' + idDesignacion + '&idEquipo=' + idEquipo
      );
    }
    // #endregion

    // #region Validación y datos del árbitro

    arbitroPorDesignacionYFuncion(
      urlBase: string,
      idDesignacion: number,
      funcion: string
    ): Promise<Online.ArbitroBasico> {
      return this.GetUniqueApi(
        urlBase,
        'cFutbolActas/arbitroPorDesignacionYFuncion/?idDesignacion=' + idDesignacion + '&funcion=' + funcion
      );
    }

    arbitroPorNumero(numero: number): Promise<Online.ArbitroBasico> {
      return this.GetUniqueApi(
        this._configuraciones.api.urlAPIs[0].urlApi,
        'cFutbolActas/arbitroPorNumero/?numero=' + numero
      );
    }

    /**
     * Comprueba si la firma de operaciones es la que tiene asignado el árbitro
     * @param idArbitro Identificador del árbitro
     * @param firma Firma que ha indicado el árbitro
     */
    comprobarFirmaOperaciones(idArbitro: number, firma: string) {
      return this.GetUniqueApi(
        this._configuraciones.api.urlAPIs[0].urlApi,
        'arbitrosFirmas/comprobar?idArbitro=' + idArbitro + '&firma=' + firma.trim()
      );
    }

    guardarFirmaArbitro(arbitro: Online.ArbitroBasico): Promise<boolean> {
      return this.Post(arbitro, 'cFutbolActas/guardarFirmaArbitro', this._configuraciones.api.urlAPIs[0].urlApi);
    }

    validacion(usuario: string, contrasenia: string): Promise<Online.ArbitroBasico> {
      return this.GetUniqueApi(
        this._configuraciones.api.urlAPIs[0].urlApi,
        'cFutbolActas/validacion/?usuario=' + usuario + '&contrasenia=' + contrasenia
      );
    }

    // #endregion
  }
  // #endregion

  // #region DeclaracionesCOVIDDesignacion
  @Injectable()
  export class DeclaracionesCOVIDDesignacionService extends iServiceOnLine {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    porDesignacion(idDesignacion: number, urlBase: string): Promise<Online.DeclaracionesCOVIDDesignacion[]> {
      return this.GetUniqueApi(
        urlBase,
        'declaracionesCOVIDDesignacion/porDesignacion?idDesignacion=' + idDesignacion
      );
    }

    post(
      declaracion: Online.DeclaracionesCOVIDDesignacion,
      urlBase: string
    ): Promise<Online.DeclaracionesCOVIDDesignacion> {
      return this.Post(declaracion, 'declaracionesCOVIDDesignacion/post', urlBase);
    }
  }
  // #endregion

  // #region Informaciones en actaCerrada
  @Injectable()
  export class InformacionEnActaService extends iServiceOnLine {
    constructor(http: HttpClient, http2: Http) {
      super(http, http2);
    }

    get(urlApi: string): Promise<Online.IObservacionesEnActa[]> {
      return this.GetUniqueApi(urlApi, 'informacionEnActa/get');
    }
  }
  // #endregion
}



// WEBPACK FOOTER //
// ./src/services/api/api.services.ts